import React from 'react'

export interface SafeResizeObserverCallback {
  (entries: ResizeObserverEntry[], observer: ResizeObserver): void
}

export const createSafeResizeObserver = (
  callback: SafeResizeObserverCallback
): ResizeObserver => {
  return new ResizeObserver((entries, observer) => {
    requestAnimationFrame(() => {
      try {
        callback(entries, observer)
      } catch (error) {
        console.warn('ResizeObserver callback error:', error)
      }
    })
  })
}

export const useSafeResizeObserver = (
  callback: SafeResizeObserverCallback,
  dependencies: React.DependencyList = []
): ResizeObserver => {
  const observerRef = React.useRef<ResizeObserver | null>(null)

  React.useEffect(() => {
    observerRef.current = createSafeResizeObserver(callback)

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect()
      }
    }
  }, dependencies)

  return observerRef.current!
}
